module.exports = __webpack_public_path__ + "img/saxophone1.15aa19e8.png";